<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12"
        ><div class="text-h5 font-weight-black my-2">
          {{ componentData.title }}
        </div>
      </v-col>
      <v-col cols="12" class="pb-5">
        <div class="text-body-1" align="left">
          {{ componentData.description }}
        </div>
      </v-col>
      <v-col>
        <v-form
          ref="form"
          v-model="componentData.formSetting.valid"
          lazy-validation
        >
          <v-text-field
            outlined
            v-model="pwdData.pwd1"
            :label="componentData.formSetting.input1.label"
            :placeholder="componentData.formSetting.input1.placeholder"
            :rules="componentData.formSetting.input1.rules"
            :error-messages="componentData.formSetting.input1.errorMsg"
            :type="pwd1Visiable ? 'text' : 'password'"
            :append-icon="pwd1Visiable ? eyeIcon1.eyeOff : eyeIcon1.eyeOn"
            @click:append="EyeSwitch(1)"
            @focus="ResetErrorValidation"
          ></v-text-field>
          <v-text-field
            outlined
            v-model="pwdData.pwd2"
            :label="componentData.formSetting.input2.label"
            :placeholder="componentData.formSetting.input2.placeholder"
            :rules="componentData.formSetting.input2.rules"
            :error-messages="componentData.formSetting.input2.errorMsg"
            :type="pwd2Visiable ? 'text' : 'password'"
            :append-icon="pwd2Visiable ? eyeIcon2.eyeOff : eyeIcon2.eyeOn"
            @click:append="EyeSwitch(2)"
            @focus="ResetErrorValidation"
          ></v-text-field>
        </v-form>
        <div class="py-2"></div>
        <v-btn
          block
          large
          color="primary"
          :loading="componentData.loading"
          @click="UpdateComplete()"
        >
          <span class="mx-2 text-capitalize">{{
            componentData.updateComplate
          }}</span>
        </v-btn>
        <div class="py-4"></div>

        <div>
          <v-btn
            text
            color="deep-purple accent-3"
            class="pa-0 pb-1"
            plain
            @click="GoBackPrevious()"
          >
            {{ componentData.backPrevious }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Account_UpdatePwd } from "@/apis/api";
export default {
  name: "UpdatePwd",
  data() {
    return {
      componentData: {
        title: "重設密碼",
        description: "請輸入6-12個字元，混合英數字之密碼",
        formSetting: {
          valid: true,
          input1: {
            label: "新密碼",
            placeholder: "請輸入",
            rules: [
              (v) => !!v || "此欄位必填",
              (v) => v.length >= 6 || "長度最少需為6個字元",
              (v) => v.length <= 20 || "長度需少於20個字元",
              (v) => /[A-Za-z]+/.test(v) || "至少包含一個英文",
              (v) => /\d+/.test(v) || "至少包含一個數字",
              (v) => /^[a-zA-Z0-9~!@#$%&_?]+$/.test(v) || "請輸入英文或數字",
            ],
            errorMsg: "",
          },
          input2: {
            label: "重新輸入新密碼",
            placeholder: "請輸入",
            rules: [
              (v) => !!v || "此欄位必填",
              (v) => v.length >= 6 || "長度最少需為6個字元",
              (v) => v.length <= 20 || "長度需少於20個字元",
              (v) => /[A-Za-z]+/.test(v) || "至少包含一個英文",
              (v) => /\d+/.test(v) || "至少包含一個數字",
              (v) => /^[a-zA-Z0-9~!@#$%&_?]+$/.test(v) || "請輸入英文或數字",
            ],
            errorMsg: "",
          },
        },
        updateComplate: "完成變更",
        backPrevious: "返回上一步",
        sendSuccess: "發送成功",
        loading: false,
      },
      pwdData: {
        pwd1: "",
        pwd2: "",
      },
      pwd1Visiable: false,
      pwd2Visiable: false,
      eyeIcon1: {
        eyeOn: "mdi-eye",
        eyeOff: "mdi-eye-off",
      },
      eyeIcon2: {
        eyeOn: "mdi-eye",
        eyeOff: "mdi-eye-off",
      },
    };
  },
  methods: {
    // 顯示密碼切換
    EyeSwitch(num) {
      if (num === 1) this.pwd1Visiable = !this.pwd1Visiable;
      if (num === 2) this.pwd2Visiable = !this.pwd2Visiable;
    },
    // 清除表單驗證
    ResetErrorValidation() {
      //   this.$refs.form.resetValidation();
      this.componentData.formSetting.input1.errorMsg = "";
      this.componentData.formSetting.input2.errorMsg = "";
    },
    // 更新密碼
    UpdateComplete() {
      // 驗證不過直接回傳
      this.$refs.form.validate();
      if (!this.$refs.form.validate()) return false;
      if (this.pwdData.pwd2 !== this.pwdData.pwd1) {
        this.componentData.formSetting.input2.errorMsg =
          "兩次密碼輸入不一致，請重新確認";
        return false;
      }

      // json格式
      let resetPwdDate = {
        email: this.$route.query.email,
        password: this.pwdData.pwd1,
      };

      this.componentData.loading = true;
      // api
      Account_UpdatePwd(resetPwdDate)
        .then((res) => {
          console.log(res.data.message);
          this.componentData.loading = false;
          // 成功跳轉頁
          this.GoUpdatePwdSuccess();
        })
        .catch((err) => {
          this.componentData.loading = false;
          this.componentData.formSetting.input2.errorMsg =
            err.response.data.message;
        });
    },
    GoBackPrevious() {
      this.$emit("switch", "ResetPwd");
    },
    // 轉更新密碼成功頁面
    GoUpdatePwdSuccess() {
      this.$emit("switch", "UpdatePwdSuccess");
    },
  },
};
</script>
